const getIconName = (iconLabel: string) => `Icon${iconLabel.replace(/ /g, "")}`;

export default getIconName;
